import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { makeStyles, Typography } from '@material-ui/core'
import { TableRow, TableCell } from '../../../components/common/ResponsiveTable'
import StatusPill from './StatusPill'
import EventMenu from './EventMenu'

const useStyles = makeStyles({
  name: { color: '#2445a7', fontWeight: 600 },
  time: { color: '#888fa9' },
})

const DateCell = ({ value }) => {
  const styles = useStyles()
  return (
    <TableCell>
      <Typography variant="body2">{dayjs(value).format('MMM D, YYYY')}</Typography>
      <Typography variant="body2" className={styles.time}>
        {dayjs(value).format('h:mm A')}
      </Typography>
    </TableCell>
  )
}

DateCell.propTypes = {
  value: PropTypes.string.isRequired,
}

const Item = ({ item, onDelete, onDuplicate, onEdit }) => {
  const styles = useStyles()
  return (
    <TableRow>
      <TableCell>
        <Typography variant="body2" className={styles.name}>
          {item.name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{item.type}</Typography>
      </TableCell>
      <DateCell value={item.startAt} />
      <DateCell value={item.endAt} />
      <TableCell>
        <Typography variant="body2">{item.location}</Typography>
      </TableCell>
      <TableCell>
        <StatusPill status={item.status} />
      </TableCell>
      <TableCell align="right">
        <EventMenu event={item} onDelete={onDelete} onDuplicate={onDuplicate} onEdit={onEdit} />
      </TableCell>
    </TableRow>
  )
}

Item.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    startAt: PropTypes.string.isRequired,
    endAt: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
}

export default Item
